import { Select, Form } from "antd";
import { BaseFormProps } from "../../lib/types.ts";

interface Option {
  value: string;
  label: string;
}

interface SelectProps extends BaseFormProps {
  defaultValue?: string;
  options: Array<Option>;
  width?: string;
  mode?: "multiple" | "tags" | undefined;
  isRequired?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | string[] | undefined;
  onChange?: (value: string | string[]) => void;
  expandDropdown? : boolean
  hidden?:boolean
}

const normalizeString = (str: string): string =>
  str
    .normalize("NFD") // Decompõe os caracteres acentuados
    .replace(/[\u0300-\u036f]/g, "") // Remove marcas de acentuação
    .toLowerCase(); // Converte para minúsculas para garantir consistência

const SelectBasic = (props: SelectProps) => {
  const width = props.width;

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      colon={false}
      rules={[{ required: props.isRequired, message: "Campo obrigatório" }]}
      style={props.hidden ? { width: "100%", display:'none' } : { width: "100%" }}
    >
      <Select
        size="middle"
        placeholder={props.placeholder || "Selecione"}
        options={props.options}
        dropdownStyle={props.expandDropdown ? {width:'75vh'} : {}}
        style={{ width: width ? `${width}` : "100%" }}
        defaultValue={props.defaultValue || undefined}
        maxTagCount="responsive"
        value={props.value || undefined}
        mode={props.mode}
        disabled={props.disabled || false}
        onChange={props.onChange}
        showSearch
        filterOption={(input, option) => {
          if (!option?.label) return false;
          const normalizedInput = normalizeString(input);
          const normalizedLabel = normalizeString(option.label);
          return normalizedLabel.includes(normalizedInput);
        }}
      />
    </Form.Item>
  );
};

export default SelectBasic;
